import { formatter as dateFormatter, HumanReadableDateFormatterProps } from './human-readable-date-formatter';
import {
  formatter as currencyFormatter,
  HumanReadableCurrencyFormatterProps,
} from './human-readable-currency-formatter.ts';

export class HumanReadableFormatter {
  /**
   * lang에 따라 요일을 반환합니다.
   * lang: kr -> '토'
   * lang: en -> 'S'
   * lang: jp -> '土'
   */
  static humanizeToDate(props: HumanReadableDateFormatterProps) {
    return dateFormatter.humanize(props);
  }

  /**
   * lang에 따라 통화를 반환합니다.
   * lang: kr -> amount: 19,000, symbol: '원'
   * lang: en -> amount: 7.32, symbol: '$'
   * lang: jp -> amount: 1,900, symbol: '¥'
   */
  static humanizeToCurrency(props: HumanReadableCurrencyFormatterProps) {
    return currencyFormatter.humanize(props);
  }
}
